<p-autoComplete minLength="2" inputId="multiple-ac-1" virtualScroll="false" [virtualScrollItemSize]="34"
                [ngModelOptions]="{ standalone: true }" [(ngModel)]="customerSelectedItem" [dropdown]="false" [forceSelection]="true"
                [suggestions]="customers" (completeMethod)="filterCustomer($event)" field="displayName"
                (onSelect)="oncustomerselected($event)" placeholder="Search Customer...">
    dataKey="id" >
</p-autoComplete>
